var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPremiumContribution(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 33,
    viewBox: "0 0 25 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.774.5H0v31.997l12.381-7.223h.012l12.381 7.223V.5z",
    fill: "#FF6C01"
  })));
}

export default SvgIconPremiumContribution;